import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MemberBasis } from './MemberBasis';
import { OpportunityValueEditor } from './OpportunityValueEditor';
import { RemoveMemberForm } from './RemoveMemberForm';
export function MemberRow({ member, removing, onRemove, canWrite = false }) {
    const [confirming, setConfirming] = useState(false);
    const removed = member.state === 'removed';
    return /*#__PURE__*/ _jsxs("li", {
        className: "space-y-1 py-2",
        "data-testid": Testids.landscapes.memberRow,
        "data-opportunity-id": member.opportunityId,
        "data-state": member.state,
        "data-basis": member.basis,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-1",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-sm font-medium",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    to: `/opportunities?watchOpportunity=${encodeURIComponent(member.opportunityId)}`,
                                    "data-testid": Testids.landscapes.memberLink,
                                    "data-opportunity-id": member.opportunityId,
                                    className: "underline-offset-2 hover:underline focus-visible:underline",
                                    children: member.opportunityTitle || member.opportunityId
                                })
                            }),
                            /*#__PURE__*/ _jsx(MemberBasis, {
                                basis: member.basis,
                                ruleKind: member.ruleKind,
                                ruleValue: member.ruleValue,
                                suppressionReason: member.suppressionReason
                            })
                        ]
                    }),
                    !removed && canWrite && /*#__PURE__*/ _jsx(OpportunityValueEditor, {
                        opportunityId: member.opportunityId
                    }),
                    canWrite && !removed && !confirming && /*#__PURE__*/ _jsx(SpecraButton, {
                        size: "sm",
                        disabled: removing,
                        variant: "outline",
                        onClick: ()=>setConfirming(true),
                        "data-testid": Testids.landscapes.removeButton,
                        children: "Remove"
                    })
                ]
            }),
            removed && /*#__PURE__*/ _jsxs("p", {
                className: "text-xs text-muted-foreground",
                "data-testid": Testids.landscapes.removalReason,
                children: [
                    "Removed",
                    member.removedBy ? ` by ${member.removedBy}` : '',
                    ": ",
                    member.removalReason
                ]
            }),
            confirming && /*#__PURE__*/ _jsx(RemoveMemberForm, {
                pending: removing,
                onCancel: ()=>setConfirming(false),
                onConfirm: (reason)=>{
                    onRemove(member.opportunityId, reason);
                    setConfirming(false);
                }
            })
        ]
    });
}
